import React, { useState, useEffect, useMemo } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import promptExamplesData from '../../data/promptExamples.json';
import '../../styles/promptSuggestions.css';
const PromptSuggestions = ({ inputWidth, refreshKey }) => {
  const { language } = useLanguage();
  const prompts = useMemo(() => promptExamplesData[language] || promptExamplesData.en || [], [language]);
  const [currentPrompt, setCurrentPrompt] = useState('');

  useEffect(() => {
    if (!prompts.length) {
      setCurrentPrompt('');
      return;
    }
    const randomPrompt = prompts[Math.floor(Math.random() * prompts.length)];
    setCurrentPrompt(randomPrompt);
  }, [prompts, refreshKey]);

  if (!currentPrompt) {
    return null;
  }

  const containerWidth = inputWidth ? `${Math.max(inputWidth * 0.9, 200)}px` : '90%';

  return (
    <div 
      className="prompt-suggestions-container"
      style={{ width: containerWidth }}
    >
      <div className="prompt-suggestion-item">
        <span className="prompt-text">"{currentPrompt}"</span>
      </div>
    </div>
  );
};

export default PromptSuggestions;

